import {TranslateLoader} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {catchError, Observable, of} from "rxjs";
import cacheBusting from "i18n-cache-busting.json";
import { environment } from "../../../environments/environment";


// Define the CacheBustingType interface
interface CacheBustingType {
  de: string;
  it: string;
  fr: string;
}

// Define a union type for the language codes
type Language = keyof CacheBustingType;

export class CustomLoader implements TranslateLoader {

  constructor(private http: HttpClient) { }

  getTranslation(lang: Language): Observable<any> {
    const cacheBustingTyped: CacheBustingType = cacheBusting;
    // @ts-ignore
    const hash = cacheBustingTyped[lang] || ''; // TypeScript knows lang is a valid key
    const url = `${environment.basePath}/assets/i18n/${lang}.json?${hash}`;
    return this.http.get<any>(url).pipe( catchError(error => { return of({})}));
  }
}